import { render, staticRenderFns } from "./PromotionResultsTable.vue?vue&type=template&id=e1806a14&"
import script from "./PromotionResultsTable.vue?vue&type=script&lang=js&"
export * from "./PromotionResultsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/PromotionResultsTable.vue
// module id = null
// module chunks = 